// Chat console ships to local and the dev deployment only; the env flag can force it on elsewhere.
const isLocal = process.env.NODE_ENV === 'development';
const isDevelopmentDeployment = process.env.REACT_APP_ENV === 'dev';

// eslint-disable-next-line import/prefer-default-export
export const isChatEnabled = process.env.REACT_APP_ENABLE_CHAT === 'true' || isLocal || isDevelopmentDeployment;
